import { useState } from 'react'
import { Card, Form, Input, Button, Typography, message, Tooltip } from 'antd'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Lock, User, Shield, Sparkles } from 'lucide-react'
import { authApi } from '../../api/auth'
import './login.css'

const { Title, Text } = Typography

export const Login = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [loading, setLoading] = useState(false)
  const [passwordForm] = Form.useForm()

  const handlePasswordLogin = async (values: { username: string; password: string }) => {
    setLoading(true)
    try {
      const res = await authApi.loginWithPassword(values)
      if (!res.token) {
        throw new Error('登录响应未包含有效凭据')
      }
      localStorage.setItem('admin_token', res.token)
      message.success('登录成功，正在进入运营指挥中心')

      const redirect = searchParams.get('redirect')
      const target = redirect && redirect.startsWith('/') ? redirect : '/dashboard'
      navigate(target, { replace: true })
    } catch (error: unknown) {
      message.error(error instanceof Error ? error.message : '账号或密码错误')
    } finally {
      setLoading(false)
    }
  }

  const handleQuickFill = () => {
    passwordForm.setFieldsValue({
      username: 'admin',
      password: 'password',
    })
    message.info('已填充默认管理员账号')
  }

  return (
    <div className="cstore-login-page">
      <div className="login-backdrop-glow" />

      <Card bordered={false} className="cstore-login-card">
        <div className="login-brand-header">
          <div className="brand-badge-icon">
            <Shield size={32} />
          </div>
          <Title level={2} className="login-app-title">
            CStore <span className="title-highlight">COMMAND</span>
          </Title>
          <Text className="login-app-desc">即时零售多商户运营管理系统</Text>
        </div>

        <Form
          form={passwordForm}
          layout="vertical"
          onFinish={handlePasswordLogin}
          className="login-form-container"
          initialValues={{ username: '', password: '' }}
        >
          <Form.Item
            name="username"
            label="管理员账号"
            rules={[{ required: true, message: '请输入管理员账号' }]}
          >
            <Input
              prefix={<User size={16} className="field-icon" />}
              placeholder="用户名 / 手机号"
              size="large"
              autoComplete="username"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="登录密码"
            rules={[{ required: true, message: '请输入登录密码' }]}
          >
            <Input.Password
              prefix={<Lock size={16} className="field-icon" />}
              placeholder="请输入密码"
              size="large"
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item style={{ marginTop: 24, marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              loading={loading}
              className="login-action-btn"
            >
              登 录
            </Button>
          </Form.Item>
        </Form>

        <div className="login-quick-bar">
          <Tooltip title="一键填入快捷测试账号">
            <Button
              type="text"
              size="small"
              icon={<Sparkles size={14} />}
              onClick={handleQuickFill}
              className="quick-fill-btn"
            >
              快捷填入测试凭据
            </Button>
          </Tooltip>
        </div>

        <div className="login-card-footer">
          <Text className="footer-copyright">
            CStore Platform · 安全鉴权与运营审计系统
          </Text>
        </div>
      </Card>
    </div>
  )
}

export default Login
